import React from 'react';
import BannerSectionStyle7 from '../Section/BannerSection/BannerSectionStyle7';
import Section from '../Section';
import AppointmentSection from '../Section/AppointmentSection';
import BreadcrumbStyle2 from '../Breadcrumb/BreadcrumbStyle2';
import FeaturesSectionStyle3 from '../Section/FeaturesSection/FeaturesSectionStyle3';
import TeamSectionStyle3 from '../Section/TeamSection/TeamSectionStyle3';
import { pageTitle } from '../../helpers/PageTitle';

const featureData = [
  {
    title: 'Efficient Patient Flow',
    subTitle:
      'Streamline patient movement through the system with automated workflows and intelligent queue management.',
    iconUrl: '/images/departments/icon_9.svg',
  },
  {
    title: 'Digital Medical Records',
    subTitle:
      'Enable smart EMR access, history tracking, reporting, and easy collaboration among care providers.',
    iconUrl: '/images/departments/icon_11.svg',
  },
  {
    title: 'Smart Appointment Scheduling',
    subTitle:
      'Reduce wait times and improve patient satisfaction with optimized scheduling tools.',
    iconUrl: '/images/departments/icon_10.svg',
  },
  {
    title: 'Interactive Dashboards',
    subTitle:
      'Track KPIs, patient trends, and performance metrics through a visual analytics dashboard.',
    iconUrl: '/images/departments/icon_12.svg',
  },
];

const doctorData = [
  {
    imgUrl: '/images/departments/related_doctor_1.jpeg',
    name: 'Chetan Gadad',
    designation: 'Solution Architect',
    description:
      'With experience in managing complex <br />medical conditions in children',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      { icon: 'fa6-brands:linkedin-in', href: '/about' },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
    btnText: 'Booking',
    btnUrl: '/appointments',
  },
];

export default function DepartmentDetails() {
  pageTitle('Department Details');

  return (
    <>
      <BreadcrumbStyle2 />

      {/* =========================
          BLUE INTRO SECTION
      ========================== */}
      <Section
        topMd={120}
        topLg={120}
        topXl={80}
        bottomMd={40}
        className="bg-blue-50 rounded-xl py-16"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

          {/* LEFT SIDE TEXT */}
          <div data-aos="fade-right">
            <h2 className="text-4xl font-semibold mb-4 text-blue-900">
              Digital Transformation for Your Clinic
            </h2>
            <p className="text-blue-800 mb-4">
              The primary objective of independent medical practices is to
              move patients through the practice efficiently and easily.
            </p>
            <p className="text-blue-800 mb-4">
              Medna Data Systems brings in best practices and transforms the medical
              practice into efficient digitalization and streamlined workflow.
            </p>
            <p className="text-blue-800">
              Visual interactive dashboards and KPI-driven tools help decision
              makers improve their services.
            </p>
          </div>

          {/* RIGHT SIDE IMAGE */}
          <div className="flex justify-center" data-aos="zoom-in">
            <img
              src="/images/departments/banner_img_3.png"
              alt="department"
              className="rounded-xl shadow-lg w-full max-w-md"
            />
          </div>
        </div>
      </Section>

      {/* =========================
          FEATURES WITH ANIMATION
      ========================== */}
      <Section
        topMd={100}
        topLg={100}
        topXl={80}
        data-aos="fade-up"
      >
        <FeaturesSectionStyle3
          sectionTitle="Our Key Features"
          sectionTitleUp="WHAT WE OFFER"
          data={featureData}
        />
      </Section>

      {/* =========================
          DOCTOR SECTION
      ========================== */}
      <Section
        topMd={100}
        topLg={100}
        topXl={80}
        data-aos="fade-up"
      >
        <TeamSectionStyle3
          sectionTitle="Related Doctors"
          sectionTitleUp="MEET OUR EXPERTS"
          data={doctorData}
        />
      </Section>

      {/* =========================
          APPOINTMENT
      ========================== */}
      <Section
        topMd={150}
        topLg={120}
        topXl={100}
        bottomMd={150}
        bottomLg={120}
        bottomXl={100}
        id="appointment"
        data-aos="fade-up"
      >
        <AppointmentSection
          sectionTitle="Appointment"
          sectionTitleUp="BOOK AN"
          imgUrl="/images/home_1/appointment.jpeg"
        />
      </Section>

      {/* =========================
          CTA BANNER
      ========================== */}
      <Section className="cs_footer_margin_0" data-aos="zoom-in-up">
        <BannerSectionStyle7
          imgUrl="/images/departments/banner_img_3.png"
          bgUrl="/images/departments/banner_bg_3.svg"
          title="Don’t Let Your Hospital <br />Take a Backseat!"
          subTitle="Schedule a demo with our experienced <br />professionals today!"
        />
      </Section>
    </>
  );
}
